import { useParams } from 'react-router';
import React, { useEffect, useState } from 'react';
import { useEvent } from '../../data/hooks/eventHooks';
import { useRequiredEnrichments } from '../../data/hooks/enrichments/useRequiredEnrichments';
import EventEnrichmentsRequired from '../screens/Enrichments/EventEnrichmentsRequired';
import EventIsClosed from '../screens/EventIsClosed/EventIsClosed';
import EventWelcomeScreen from '../screens/EventWelcomeScreen';
import LoadEnrichments from '../loaders/LoadEnrichments';
import WaitWhileBusy from '../WaitWhileBusy';
import config from '../../configs/config';
import { useIsDemoMode } from '../../data/hooks/ui/useIsDemoMode';

const EventRouteOverrider = (props) => {
    const { children } = props,
        params = useParams(),
        event = useEvent(params.eventId),
        requiredEnrichments = useRequiredEnrichments(event.id),
        [showEnrichments, setShowEnrichments] = useState(false),
        isDemoMode = useIsDemoMode();

    useEffect(() => {
        if (requiredEnrichments.length && !showEnrichments) {
            setShowEnrichments(true);
        }
    }, [requiredEnrichments]);

    function handleEnrichmentsComplete() {
        setShowEnrichments(false);
    }

    if (!isDemoMode) {
        if (event.closed) {
            return <EventIsClosed {...params} />;
        } else if (!event.isWelcomeScreenShown && event.lastReceivedUpdates && event.welcome_text) {
            // note: check above for lastReceivedUpdates since it's the only place where to get the isWelcomeScreenShown (prevents showing screen before all is loaded)
            return <EventWelcomeScreen {...params} />;
        } else if (showEnrichments && !config.skipRequiredEnrichments) {
            return <EventEnrichmentsRequired {...params} onContinueClicked={handleEnrichmentsComplete} />;
        }
    }

    return children;
};

export default (props) => (
    <LoadEnrichments eventId={props.match.params.eventId}>
        <WaitWhileBusy>
            <EventRouteOverrider {...props} />
        </WaitWhileBusy>
    </LoadEnrichments>
);
